import React from 'react';
import PropTypes from 'prop-types';
import MemberProfilePanel from '@common/MemberProfilePanel';
import AccountAccessField from './components/AccountAccessField';
import MemberSubscription from './components/MemberSubscription';
import AccountMemberOptionsMenu from '../AccountMemberOptionsMenu';
import { PROFILE_VARIANTS } from './constants';

const AccountMemberProfilePanel = ({
  accessLevels,
  companies,
  companySearchInput,
  isFetchingCompanies,
  isFetchingRoles,
  isFetchingUserOfferings,
  loadingOfferings,
  licensingTrialMessages,
  offeringsDataError,
  overSheetLimitData,
  savingDropdown,
  onAccessLevelChange,
  onChangeCompanyInput,
  onChangeRoleInput,
  onCompanyChange,
  onLicenseChange,
  onResend,
  onRemove,
  onRoleChange,
  onTryAgainClick,
  roles,
  roleSearchInput,
  selectedAccessLevel,
  selectedCompany,
  selectedRole,
  subscription,
  user,
  userOfferingsDataError,
  ...rest
}) => {
  return (
    <MemberProfilePanel
      {...rest}
      companies={companies}
      companySearchInput={companySearchInput}
      roleSearchInput={roleSearchInput}
      isFetchingCompanies={isFetchingCompanies}
      isFetchingRoles={isFetchingRoles}
      onChangeCompanyInput={onChangeCompanyInput}
      onChangeRoleInput={onChangeRoleInput}
      onCompanyChange={onCompanyChange}
      onRoleChange={onRoleChange}
      optionsMenu={
        <AccountMemberOptionsMenu
          accessLevels={user?.accessLevels}
          email={user?.email}
          horizontal
          imageUrl={user?.imageUrl}
          name={user?.name}
          onRemove={onRemove}
          onResend={onResend}
          status={user?.status}
          style={{ border: 'none' }}
          userId={user?.id}
        />
      }
      roles={roles}
      selectedCompany={selectedCompany}
      selectedRole={selectedRole}
      user={user}
      variant={PROFILE_VARIANTS.ACCOUNT}
    >
      <AccountAccessField
        accessLevels={accessLevels}
        onAccessLevelChange={onAccessLevelChange}
        selectedAccessLevel={selectedAccessLevel}
      />

      <MemberSubscription
        loadingSubscriptions={loadingOfferings || isFetchingUserOfferings}
        offerings={subscription?.currentOfferings}
        offeringsDataError={offeringsDataError || userOfferingsDataError}
        onLicenseChange={onLicenseChange}
        onTryAgainClick={onTryAgainClick}
        overSheetLimitData={overSheetLimitData}
        savingDropdown={savingDropdown}
        licensingTrialMessages={licensingTrialMessages}
      />
    </MemberProfilePanel>
  );
};

AccountMemberProfilePanel.propTypes = {
  accessLevels: PropTypes.array,
  companies: PropTypes.array,
  companySearchInput: PropTypes.string,
  isFetchingCompanies: PropTypes.bool,
  isFetchingRoles: PropTypes.bool,
  isFetchingUserOfferings: PropTypes.bool,
  loadingOfferings: PropTypes.bool,
  offeringsDataError: PropTypes.bool,
  overSheetLimitData: PropTypes.object,
  savingDropdown: PropTypes.object.isRequired,
  onAccessLevelChange: PropTypes.func,
  onChangeCompanyInput: PropTypes.func,
  onChangeRoleInput: PropTypes.func,
  onCompanyChange: PropTypes.func,
  onLicenseChange: PropTypes.func,
  onResend: PropTypes.func,
  onRemove: PropTypes.func,
  onRoleChange: PropTypes.func,
  onTryAgainClick: PropTypes.func,
  roles: PropTypes.array,
  roleSearchInput: PropTypes.string,
  selectedAccessLevel: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  selectedCompany: PropTypes.object,
  selectedRole: PropTypes.object,
  subscription: PropTypes.object,
  licensingTrialMessages: PropTypes.shape({
    member: PropTypes.string,
    subscriptionMessages: PropTypes.objectOf(
      PropTypes.shape({
        daysRemaining: PropTypes.number,
        textKey: PropTypes.string,
      })
    ),
  }),
  user: PropTypes.object,
  userOfferingsDataError: PropTypes.object,
};

AccountMemberProfilePanel.defaultProps = {
  licensingTrialMessages: null,
};

export default AccountMemberProfilePanel;
